/* Native Shopify selling plans; no subscription is selected without a shopper action. */
(() => {
  'use strict';
  window.HBCartPurchase = {
    create({config,request,money}) {
      let settings = null, settingsPromise = null;
      const products = new Map();
      const escape = value => String(value ?? '').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
      const plan = item => item.selling_plan_allocation?.selling_plan;
      const gift = item => item.handle === 'free-bag-of-pretzel-bites' || item.properties?._is_free_gift === 'true';
      const box = cart => cart.items.some(item=>item.properties?._hb_box === '20261016');
      const paid = cart => cart.items.filter(item=>!gift(item) && item.requires_shipping !== false && !item.properties?._prepaid_shipping && !/swipe|protection/i.test(item.handle || ''));
      const subItems = cart => paid(cart).filter(item=>plan(item));
      const minimum = () => Math.round((settings?.minimumSubscriptionAmount || 20)*100);
      const monthly = () => settings?.plans?.find(p=>!p.prepaid && p.interval==='MONTH' && p.intervalCount===1);
      const perBox = item => {
        const months = plan(item)?.name?.match(/^(\d+)\s+months?\s+prepaid$/i);
        const amount = item.selling_plan_allocation?.price != null ? item.selling_plan_allocation.price * item.quantity : item.final_line_price;
        return Math.round(amount / (months ? Number(months[1]) : 1));
      };
      const subTotal = cart => subItems(cart).reduce((sum,item)=>sum+perBox(item),0);
      function allocation(item,id) {
        return products.get(item.handle)?.variants?.find(v=>Number(v.id)===Number(item.variant_id))?.selling_plan_allocations?.find(a=>String(a.selling_plan_id)===String(id));
      }
      async function prepare(cart) {
        if(!settingsPromise) settingsPromise=request('apps/manage-subscriptions?r=config').then(value=>{settings=value;return value;}).catch(()=>{settingsPromise=null;});
        await settingsPromise;
        await Promise.all(paid(cart).map(async item=>{
          if(products.has(item.handle))return;
          try { products.set(item.handle,await request('products/'+encodeURIComponent(item.handle)+'.js')); } catch (_) {}
        }));
      }
      function html(cart) {
        if(!cart.item_count)return '';
        if(box(cart))return '<h3>Purchase options</h3><p class="hb-cart__purchase-note">Your Build Your Own Box is a one-time purchase with its own box discount.</p>';
        const mp=monthly(), current=subItems(cart), selected=current.length>0;
        const eligible=mp && paid(cart).some(item=>allocation(item,mp.sellingPlanId));
        if(settings?.enabled===false || (!eligible && !selected))return '';
        const threshold=money(Math.round((settings?.perks?.thresholdAmount || 50)*100)).replace(/\.00$/,'');
        const name=current.some(item=>plan(item)?.name !== mp?.name) ? 'Current subscription' : 'Subscribe & save';
        return '<h3>How do you want it?</h3><div class="hb-cart__purchase-choices" role="group" aria-label="Purchase type">'
          +'<button type="button" class="hb-cart__purchase-choice'+(selected?' is-selected':'')+'" data-hb-purchase="subscription" aria-pressed="'+selected+'"'+(!eligible?' disabled':'')+'><span class="hb-cart__purchase-radio" aria-hidden="true"></span><span><strong>'+escape(selected?name:'Subscribe & save')+(mp?.discountPct?' · '+Number(mp.discountPct)+'% off':'')+'</strong><span>Free bag of an unreleased flavor every month.<br>Free shipping on subscription boxes over '+threshold+'.</span><small>Delivered monthly · '+Number(settings?.minOrdersBeforeCancel || 2)+' orders before cancellation.</small></span></button>'
          +'<button type="button" class="hb-cart__purchase-choice'+(!selected?' is-selected':'')+'" data-hb-purchase="onetime" aria-pressed="'+(!selected)+'"><span class="hb-cart__purchase-radio" aria-hidden="true"></span><span><strong>One-time purchase</strong><span>One order, no subscription.</span></span></button></div><a class="hb-cart__purchase-terms" href="/pages/subscription-terms-conditions" target="_blank" rel="noopener">View subscription details</a>';
      }
      async function reconcile(cart,{joinNew=false}={}) {
        await prepare(cart);
        let current=subItems(cart);
        if(joinNew && current.length && !box(cart)) {
          const id=plan(current[0]).id;
          for(const item of paid(cart)) {
            if(!plan(item) && allocation(item,id))cart=await request('cart/change.js',{id:item.key,quantity:item.quantity,selling_plan:Number(id)});
          }
          current=subItems(cart);
        }
        const qualified=current.length>0 && subTotal(cart)>=minimum() && !box(cart);
        const existing=cart.items.filter(gift);
        const wanted=qualified ? Number(config.subscriptionGift?.id || 0) : 0;
        let kept=false;
        for(const item of existing) {
          if(wanted && Number(item.variant_id)===wanted && !kept && item.properties?._requires_subscription==='true') {
            kept=true;
            if(item.quantity!==1)cart=await request('cart/change.js',{id:item.key,quantity:1});
          } else cart=await request('cart/change.js',{id:item.key,quantity:0});
        }
        if(wanted && !kept) {
          await request('cart/add.js',{items:[{id:wanted,quantity:1,properties:{_is_free_gift:'true',_requires_subscription:'true',_hb_subscription_gift:'20260930',Type:'Free Bag','Free Flavor':config.subscriptionGift.title}}]});
          cart=await request('cart.js');
        }
        const charged=cart.items.find(item=>gift(item)&&item.final_line_price>0);
        if(charged) {
          await request('cart/change.js',{id:charged.key,quantity:0});
          throw new Error('The free flavor could not be applied, so it was removed to avoid a charge. Please try again.');
        }
        if(qualified&&!wanted)throw new Error('The subscriber flavor is currently unavailable. Please choose one-time purchase or contact us before subscribing.');
        return cart;
      }
      async function choose(value,cart) {
        await prepare(cart);
        if(box(cart))throw new Error('Build Your Own Box uses its own one-time box discount.');
        if(value==='onetime') {
          for(const item of cart.items) {
            if(gift(item)||item.properties?._prepaid_shipping==='true')cart=await request('cart/change.js',{id:item.key,quantity:0});
            else if(plan(item))cart=await request('cart/change.js',{id:item.key,quantity:item.quantity,selling_plan:null});
          }
          return request('cart/update.js',{attributes:{_hb_purchase_choice:'onetime',_hb_plan_id:'',_hb_sub_commitment:''}});
        }
        const mp=monthly();
        if(!mp || settings?.enabled===false)throw new Error('Subscriptions are temporarily unavailable. Please try again.');
        const eligible=paid(cart).filter(item=>allocation(item,mp.sellingPlanId));
        if(!eligible.length)throw new Error('These items are not available on subscription.');
        const predicted=eligible.reduce((sum,item)=>sum+allocation(item,mp.sellingPlanId).price*item.quantity,0);
        if(predicted<minimum())throw new Error('Subscriptions require '+money(minimum())+' after the subscription discount. Add another item to subscribe.');
        if(!config.subscriptionGift?.id)throw new Error('The subscriber flavor is currently unavailable. Please try again later.');
        const original=cart, changed=[];
        try {
          for(const item of cart.items.filter(item=>item.properties?._prepaid_shipping==='true'))cart=await request('cart/change.js',{id:item.key,quantity:0});
          for(const item of eligible) {
            cart=await request('cart/change.js',{id:item.key,quantity:item.quantity,selling_plan:Number(mp.sellingPlanId)});
            changed.push(item);
          }
          cart=await request('cart/update.js',{attributes:{_hb_purchase_choice:'subscription',_hb_plan_id:String(mp.sellingPlanId),_hb_sub_commitment:''}});
          return await reconcile(cart);
        } catch(error) {
          // Applying a plan and claiming its gift are one shopper action. Restore it on failure.
          try {
            cart=await request('cart.js');
            const same=(a,b)=>Number(a.variant_id)===Number(b.variant_id)&&JSON.stringify(a.properties||{})===JSON.stringify(b.properties||{});
            for(const item of changed) {
              const now=cart.items.find(row=>same(row,item));
              if(now)cart=await request('cart/change.js',{id:now.key,quantity:now.quantity,selling_plan:plan(item)?.id || null});
            }
            for(const item of cart.items.filter(gift))if(!original.items.some(row=>same(row,item)))cart=await request('cart/change.js',{id:item.key,quantity:0});
            for(const item of original.items.filter(item=>gift(item)||item.properties?._prepaid_shipping==='true')) {
              if(!cart.items.some(row=>same(row,item))) {
                await request('cart/add.js',{items:[{id:item.variant_id,quantity:item.quantity,properties:item.properties||{},...(plan(item)?{selling_plan:plan(item).id}:{})}]});
                cart=await request('cart.js');
              }
            }
            await request('cart/update.js',{attributes:{_hb_purchase_choice:original.attributes?._hb_purchase_choice || '',_hb_plan_id:original.attributes?._hb_plan_id || '',_hb_sub_commitment:original.attributes?._hb_sub_commitment || ''}});
          } catch (_) { throw new Error('The subscription change was interrupted. Review your refreshed cart and purchase option before checkout.'); }
          throw error;
        }
      }
      function validate(cart) {
        if(subItems(cart).length && subTotal(cart)<minimum())throw new Error('Your subscription needs at least '+money(minimum())+' after discounts. Add another item or choose one-time purchase.');
      }
      return {prepare,html,choose,reconcile,validate,isSubscribed:cart=>subItems(cart).length>0};
    }
  };
})();
